import {Record, Form} from '../../stores/Form';

export type MarkerType = {
    id: string;
    label?: string;
    address: string;
    routeId?: string;
    selected: boolean;
    show?: boolean;
    route?: {id: string; color?: string; title?: string; isShow: boolean};
    color?: string;
    isStart?: boolean;
    isEnd?: boolean;
    record?: Record;
} & google.maps.LatLngLiteral;

export type InfoWindowType = {
    event?: google.maps.MapMouseEvent;
    point: MarkerType;
};

export type ItemType = {
    id: number;
    data?: Record;
};

export type LocationType = {
    id: number;
    data?: Record;
    items?: ItemType[];
    itemsSubform: Form | null;
};

export type RouteType = {
    id: string;
    color?: string;
    title?: string;
    markers: MarkerType[];
    isShow: boolean;
    locations?: LocationType[];
    locationSubform: Form | null;
    locationSubformOpen: boolean;
    locationSubformReload: boolean;
    locationSubformLoading: boolean;
    isCollapsableOpen?: boolean;
    data?: Record;
    selectedDocuments?: Record[];
    isSelected?: boolean;
    startMarker?: MarkerType;
    endMarker?: MarkerType;
    shouldDisplay?: boolean;
};

export type MapSettings = {
    showLine: boolean;
    showAddresses: boolean;
    showStartEnd: boolean;
};

export enum MovingLocation {
    table1 = 'table-1',
    table2 = 'table-2',
    map = 'map'
}
